export default __webpack_public_path__ + "static/media/v4.8aa65f0e.jpg";